const CONSTANTS = {
  MSIKEY: 'AVEVA.UnifiedEngineering.Desktop.msi',
  FILEKEY_CLOUDSTORAGE: 'AVEVA.Cloud.Storage.Setup.zip',
  SIGNEDCATALOGKEY: 'SignedCatalog3rdPartyApps.cat'
};

export default CONSTANTS;
